import React, {useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import moment from 'moment'
import {KTSVG, useDebounce} from '../../../../_metronic/helpers'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'
import AddNewDedicatedNumber from './modal/AddNewDedicatedNumber'
import EditDedicatedNumber from './modal/EditDedicatedNumber'
import {
  deleteDedicatedNumberList,
  getDedicatedNumberList,
} from './DedicatedNumberSlice/DedicatedNumberSlice'
import {GetGatewayManagementList} from '../GatewayManagement/GatewayManagementSlice/GatewayManagementSlice'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import Select from 'react-select'
import NodataYet from '../../../Components/NodataYet'
import ReactPaginate from 'react-paginate'
import {
  AVAILABILITY_OPTIONS,
  AVAILABILITY_TYPE,
  BILLING_STATUS_OPTIONS,
  BILLING_STATUS_TYPE,
  DEDICATED_NUMBER_STATUS_OPTIONS,
  NUMBER_TYPE,
} from '../../../Utils/Constant/ConstantForWebsite'
import {useLoadedData} from '../../../hooks/useGetLoadedData'
const DedicatedNumberList = () => {
  //////////////////////////////////All Const///////////////////////////
  const dispatch = useDispatch()
  const {calculate, loadedData, setLoadedData} = useLoadedData()

  ////////////////////////////////////////ALL USESTATE//////////////////////////////////
  const [showVirtualNumber, setShowVirtualNumber] = useState(false)
  const [editNumber, setEditNumber] = useState(false)
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [editNumberData, setEditNumberData] = useState<any>({
    country: {value: 'au', label: 'Australia'},
  })
  const [deleteIds, setDeleteIds] = useState<any>()
  const dedicatedNumber = useSelector((state: any) => state?.dedicatedNumber?.dedicatedNumberList)
  const paymentGatewayList = useSelector((state: any) => state?.paymentGateway?.GatewayManagement)

  const [apply, setApply] = useState(false)
  const [filterOpen, setFilterOpen] = useState(false)
  const [page, setPage] = useState({
    page: 1,
    size: 10,
    searchKey: '',
    availability: '',
    status: '',
    billingStatus: '',
  })

  const debouncedSearchTerm = useDebounce(page?.searchKey, 3000)

  /////////////////////////////////////USE-EFFECT//////////////////////////////////////
  useEffect(() => {
    dispatch(getDedicatedNumberList(page))
    dispatch(GetGatewayManagementList())
  }, [debouncedSearchTerm, page.page, page.size, apply])

  useEffect(() => {
    if (dedicatedNumber && dedicatedNumber?.total) {
      const calculatedData = calculate(page.page, page.size, dedicatedNumber.total)
      setLoadedData(calculatedData)
    }
  }, [dedicatedNumber, page.page, page.size])

  useEffect(() => {
    if (confirm == true) {
      dispatch(
        deleteDedicatedNumberList({
          id: deleteIds,
        })
      ).then(() => {
        dispatch(getDedicatedNumberList(page))
      })
      setConfirm(false)
    }
  }, [confirm])

  /////////////////////////////////use-MEMO//////////////////////////////////////

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        Message={'Are you sure, you want to delete this dedicated number?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )
  const VNPopup = useMemo(
    () => (
      <AddNewDedicatedNumber
        show={showVirtualNumber}
        handleClose={() => setShowVirtualNumber(false)}
      />
    ),
    [showVirtualNumber]
  )

  const editVNnumber = useMemo(
    () => (
      <EditDedicatedNumber
        data={editNumberData}
        setData={setEditNumberData}
        show={editNumber}
        page={page}
        handleClose={() => setEditNumber(false)}
      />
    ),
    [editNumber, editNumberData]
  )
  ///////////////////////////////////ALL Function //////////////////////////////

  const handleDelete = (id: any) => {
    setOpen(true)
    setDeleteIds(id)
  }

  return (
    <>
      {VNPopup}
      {editVNnumber}
      {confirmation}
      <div className='card mb-0'>
        <div className='card-header card-header-stretch border-bottom-0'>
          <div className='card-title d-flex align-items-center'>
            <div className='d-flex align-items-center position-relative my-1'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-1 position-absolute ms-6'
              />
              <input
                type='text'
                data-kt-user-table-filter='search'
                className='form-control form-control-solid w-250px ps-14'
                placeholder='Search number'
                value={page?.searchKey}
                onChange={(e) => setPage({...page, searchKey: e.target.value})}
              />
            </div>

            <div onMouseEnter={() => setFilterOpen(true)} onMouseLeave={() => setFilterOpen(false)}>
              <button
                className={`position-relative btn btn-light-primary ms-3 me-3 filter_btn ${
                  filterOpen && 'show menu-dropdown'
                } `}
                data-kt-menu-placement='bottom-end'
              >
                <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
                Filter
              </button>

              <div
                className={`position-absolute menu menu-sub menu-sub-dropdown w-250px w-md-300px ${
                  filterOpen && 'show '
                }`}
                // data-kt-menu='true'
              >
                <div className='px-7 py-5'>
                  <div className='mb-10'>
                    <label className='form-label fw-bold'>Billing Status:</label>

                    <div>
                      <Select
                        value={{value: page?.billingStatus, label: page?.billingStatus}}
                        options={BILLING_STATUS_OPTIONS}
                        onChange={(e: any) =>
                          setPage({...page, billingStatus: e.value, page: 1, size: 10})
                        }
                      />
                    </div>
                  </div>

                  <div className='mb-10'>
                    <label className='form-label fw-bold'>Status:</label>
                    <Select
                      value={{value: page?.status, label: page?.status}}
                      options={DEDICATED_NUMBER_STATUS_OPTIONS}
                      onChange={(e: any) => setPage({...page, status: e.value, page: 1, size: 10})}
                    />
                  </div>

                  <div className='mb-10'>
                    <label className='form-label fw-bold'>Availability:</label>
                    <Select
                      value={{value: page?.availability, label: page?.availability}}
                      options={AVAILABILITY_OPTIONS}
                      onChange={(e: any) =>
                        setPage({...page, availability: e.value, page: 1, size: 10})
                      }
                    />
                  </div>

                  <div className='d-flex justify-content-end'>
                    <button
                      type='reset'
                      className='btn btn-sm btn-white btn-active-light-primary me-2'
                      onClick={() => {
                        setPage({
                          page: 1,
                          size: 10,
                          searchKey: '',
                          availability: '',
                          status: '',
                          billingStatus: '',
                        })
                      }}
                    >
                      Reset
                    </button>

                    <button
                      type='submit'
                      className='btn btn-sm btn-primary'
                      data-kt-menu-dismiss='true'
                      onClick={() => {
                        setApply(!apply)
                        setFilterOpen(false)
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {AuthenticateUser('create-backend-dedicatednumber') && (
            <div className='card-toolbar m-0'>
              <div className='d-flex gap-3 align-items-center'>
                <button className='btn btn-primary' onClick={() => setShowVirtualNumber(true)}>
                  Create
                </button>
              </div>
            </div>
          )}
        </div>
        {dedicatedNumber?.items?.length > 0 ? (
          <div className='card-body pt-2'>
            <div className='tab-content'>
              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bold text-muted text-uppercase'>
                      <th>Number</th>
                      <th>Type</th>
                      <th>Gateway</th>
                      <th>Assigned User</th>
                      <th>Activation Date</th>
                      <th>Expiration Date</th>
                      <th>Billing Status</th>
                      <th>Status</th>
                      <th>Availability</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className='text-gray-600'>
                    {dedicatedNumber?.items.map((val: any, id: number) => (
                      <tr key={id}>
                        <td>{val?.audNumber}</td>
                        <td>
                          <span
                            className={`${
                              val?.type === NUMBER_TYPE.SMS
                                ? 'badge badge-light-success '
                                : 'badge badge-light-info'
                            }`}
                          >
                            {val?.type}
                          </span>
                        </td>
                        <td>
                          {
                            paymentGatewayList?.find((key: any) => key?._id == val?.gateway)
                              ?.gatewayName
                          }
                        </td>
                        <td>{val?.assignedOwnerName?.at(0)}</td>
                        <td>
                          {val?.activationTime !== null
                            ? `${moment(val?.activationTime).format('DD/MM/YY')} at ${moment(
                                val?.activationTime
                              ).format('HH:mm')}`
                            : ''}
                        </td>
                        <td>
                          {' '}
                          {val?.expirationTime !== null
                            ? `${moment(val?.expirationTime).format('DD/MM/YY')} at ${moment(
                                val?.expirationTime
                              ).format('HH:mm')}`
                            : ''}
                        </td>
                        <td>
                          <span
                            className={`${
                              val?.billingStatus === BILLING_STATUS_TYPE.MONTHLY
                                ? 'badge badge-light-info '
                                : val?.billingStatus === BILLING_STATUS_TYPE.YEARLY
                                ? 'badge badge-light-success'
                                : 'badge badge-light-dark'
                            }`}
                          >
                            {val?.billingStatus?.charAt(0).toUpperCase() +
                              val?.billingStatus?.slice(1)}
                          </span>
                        </td>
                        <td>
                          <span
                            className={`${
                              val?.status === 'active'
                                ? 'badge badge-light-success '
                                : 'badge badge-light-danger'
                            }`}
                          >
                            {val?.status?.charAt(0).toUpperCase() + val?.status?.slice(1)}
                          </span>
                        </td>
                        <td>
                          <span
                            className={`${
                              val?.availability === AVAILABILITY_TYPE.AVAILABLE
                                ? 'badge badge-light-success '
                                : val?.availability === AVAILABILITY_TYPE.ALLOCATED
                                ? 'badge badge-light-info'
                                : 'badge badge-light-danger'
                            }`}
                          >
                            {val?.availability?.charAt(0).toUpperCase() +
                              val?.availability.slice(1)}
                          </span>
                        </td>
                        <td className='text-end'>
                          {AuthenticateUser('edit-backend-dedicatednumber') && (
                            <span
                              onClick={() => {
                                const editData = {
                                  _id: val?._id,
                                  audNumber: val?.audNumber,
                                  gateway: val?.gateway,
                                  country: val?.country,

                                  billingStatus: val?.billingStatus,
                                  activationTime:
                                    val?.activationTime == null ? new Date() : val?.activationTime,
                                  expirationTime:
                                    val?.expirationTime == null ? new Date() : val?.expirationTime,
                                  status: val?.status,

                                  assignedUser:
                                    val?.assignedUser !== ''
                                      ? {
                                          value: val?.assignedUser,
                                          label: val?.assignedOwnerName?.[0],
                                        }
                                      : {value: '', label: 'select'},
                                }

                                setEditNumber(true)
                                setEditNumberData({...editData})
                              }}
                              className='btn btn-bg-light btn-active-color-primary btn-sm'
                            >
                              Edit
                            </span>
                          )}
                          {AuthenticateUser('delete-backend-dedicatednumber') && (
                            <span
                              onClick={() => handleDelete(val?._id)}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-3'
                            >
                              <KTSVG
                                path='/media/icons/duotune/general/gen027.svg'
                                className='svg-icon-3'
                              />
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className='abcd'>
              <select
                onChange={(e) => {
                  setPage({...page, size: parseInt(e.target.value)})
                }}
                value={page.size}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
              Show {loadedData.startLoad} - {loadedData.endLoad} of {dedicatedNumber?.total}
              <ReactPaginate
                previousLabel='<'
                nextLabel='>'
                pageCount={dedicatedNumber?.totalPages}
                onPageChange={(e) => {
                  setPage({...page, page: e.selected + 1})
                }}
                containerClassName={'pagination'}
                previousLinkClassName={'pagination__link'}
                nextLinkClassName={'pagination__link'}
                disabledClassName={'pagination__link--disabled'}
                activeClassName={'pagination__link--active'}
              />
            </div>
          </div>
        ) : (
          <NodataYet />
        )}
      </div>
    </>
  )
}

export default DedicatedNumberList
